import ForwardTracker from "../../../../prop-trackers/forward-tracker.js";
import ValueTracker from "../../../../prop-trackers/value-tracker.js";
import { Mapper, ValueMapper } from "../../../../prop-tracker-utils/mapper.js";

class LabelTrackerCreator extends ForwardTracker {
    constructor(labelDataTracker, labelCreator) {
        const loadMapper = new Mapper(labelDataTracker, (key) => new SingleLoadMapper(labelCreator));
        super(loadMapper);
    }
}

class SingleLoadMapper extends ValueMapper {
    constructor(labelCreator) {
        super();

        this._labelCreator = labelCreator;

        this._dataTracker = new ValueTracker();
        this._label = null;
        this._valueTracker = new ValueTracker();

        this._dataTracker.listenNeedsUpdate(() => this.protected_needsUpdate());
    }

    setValue(data) {
        if (data) {
            this._dataTracker.setValue(data);
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._dataTracker.deleteValue();
    }

    protected_startUpdate() {
        this._dataTracker.updateIfNeeded(({ prop: { oldExists, newExists } }) => {
            if (newExists) {
                this._label = this._labelCreator.create();
                this._valueTracker.setValue(this._label);
            } else {
                this._labelCreator.dispose(this._label);
                this._label = null;
                this._valueTracker.deleteValue();
            }
        });

        return this._valueTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._valueTracker.finishUpdate();
    }
}

export default LabelTrackerCreator;
